import {
  LOGIN_CHECK_TOKEN_BEGIN,
  LOGIN_CHECK_TOKEN_SUCCESS,
  LOGIN_CHECK_TOKEN_FAILURE,
  LOGIN_CHECK_TOKEN_DISMISS_ERROR,
} from './constants';

import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function checkToken(token,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: LOGIN_CHECK_TOKEN_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post(SERVER_PATH + '/users/loginOutseta', {
        token:token,
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success===1){
            dispatch({
              type: LOGIN_CHECK_TOKEN_SUCCESS,
              data: res.data,
            });
            resolve(res)
          }else{
            reject("Login failed.")
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: LOGIN_CHECK_TOKEN_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissCheckTokenError() {
  return {
    type: LOGIN_CHECK_TOKEN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_CHECK_TOKEN_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        checkTokenPending: true,
        checkTokenError: null,
      };

    case LOGIN_CHECK_TOKEN_SUCCESS:
      // The request is success
      // The request is success
      let logged = action.data.success === 1? true:false;
      // The request is success
      if(logged)
      {
        localStorage.setItem("logged", logged);
        localStorage.setItem("username", action.data.username);
        localStorage.setItem("user_token", action.data.token);
        localStorage.setItem("user_id", action.data.user);
        localStorage.setItem("role", action.data.role);
        localStorage.setItem("avatar",action.data.avatar);
        localStorage.setItem("token_outseta",action.data.token_outseta);
      } 
      return {
        ...state,
        openAlert:!logged,
        logged: logged,
        checkTokenPending: false,
        checkTokenError: null,
      };

    case LOGIN_CHECK_TOKEN_FAILURE:
      // The request is failed
      return {
        ...state,
        checkTokenPending: false,
        checkTokenError: action.data.error,
      };

    case LOGIN_CHECK_TOKEN_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        checkTokenError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login/redux/checkToken.js